@let val = value();
<section class="profile-details">
  <h1 class="profile-details__header">{{ title() }}</h1>
  <button mat-button type="button" class="button" (click)="onBack()">
    {{ labels.back }}
  </button>
  @if (val) {
    <div class="profile-details__body">
      <div
        class="profile-details__key profile-details_top profile-details_top-left"
      >
        {{ profileKeys.profileName }}
      </div>
      <div
        class="profile-details__value profile-details_top profile-details_top-right"
      >
        {{ val.profileName || labels.na }}
      </div>
      <div class="profile-details__key">
        {{ profileKeys.maxCertificateValidityInDays }}
      </div>
      <div class="profile-details__value">
        {{
          val.maxCertificateValidityInDays === 0
            ? 0
            : val.maxCertificateValidityInDays || labels.na
        }}
      </div>
      <div class="profile-details__key">
        {{ profileKeys.allowExtensionOverride }}
      </div>
      <div class="profile-details__value">
        @if (val.allowExtensionOverride) {
          <svg-icon icon="checkbox-checked"></svg-icon>
        } @else if (!val.allowExtensionOverride) {
          <svg-icon icon="checkbox-unchecked"></svg-icon>
        } @else {
          {{ labels.na }}
        }
      </div>
      <div class="profile-details__key">
        {{ profileKeys.overridableExtensionOIDs }}
      </div>
      <div class="profile-details__value">
        <ul>
          @for (
            overridableExtensionOID of val.overridableExtensionOIDs;
            track overridableExtensionOID
          ) {
            <li>{{ overridableExtensionOID || labels.na }}</li>
          }
        </ul>
      </div>
      <div class="profile-details__key">
        {{ profileKeys.criticalBasicConstraints }}
      </div>
      <div class="profile-details__value">
        @if (val.criticalBasicConstraints) {
          <svg-icon icon="checkbox-checked"></svg-icon>
        } @else if (!val.criticalBasicConstraints) {
          <svg-icon icon="checkbox-unchecked"></svg-icon>
        } @else {
          {{ labels.na }}
        }
      </div>
      <div class="profile-details__key">
        {{ profileKeys.criticalKeyUsage }}
      </div>
      <div class="profile-details__value">
        @if (val.criticalKeyUsage) {
          <svg-icon icon="checkbox-checked"></svg-icon>
        } @else if (val.criticalKeyUsage === false) {
          <svg-icon icon="checkbox-unchecked"></svg-icon>
        } @else {
          {{ labels.na }}
        }
      </div>
      <div class="profile-details__key">
        {{ profileKeys.keyUsages }}
      </div>
      <div class="profile-details__value">
        <div class="profile-details__key-usages">
          @for (ku of keyUsagesStatus(); track ku.displayName) {
            <div class="profile-details__checkbox-container">
              <svg-icon
                [icon]="
                  ku.isPresent ? 'checkbox-checked' : 'checkbox-unchecked'
                "
              ></svg-icon>
              <div class="profile-details__checkbox-text">
                {{ ku.displayName }}
              </div>
            </div>
          }
        </div>
      </div>
      <div class="profile-details__key">
        {{ profileKeys.criticalExtendedKeyUsage }}
      </div>
      <div class="profile-details__value">
        @if (val.criticalExtendedKeyUsage) {
          <svg-icon icon="checkbox-checked"></svg-icon>
        } @else if (val.criticalExtendedKeyUsage === false) {
          <svg-icon icon="checkbox-unchecked"></svg-icon>
        } @else {
          {{ labels.na }}
        }
      </div>
      <div class="profile-details__key">
        {{ profileKeys.extendedKeyUsages }}
      </div>
      <div class="profile-details__value">
        <ul>
          @for (eku of val.extendedKeyUsages; track eku) {
            <li>{{ extendedKeyUsages[eku] || eku }}</li>
          }
        </ul>
      </div>
      <div class="profile-details__key">
        {{ profileKeys.crlDistributionEndpoint }}
      </div>
      <div
        class="profile-details__value profile-details--crl-distribution-endpoint"
      >
        <div>
          {{ val.crlDistributionEndpoint || labels.na }}
        </div>
        <div class="profile-details__checkbox-container">
          <svg-icon
            [icon]="
              val.criticalCRLDistributionPoint
                ? 'checkbox-checked'
                : 'checkbox-unchecked'
            "
          >
          </svg-icon>
          <div class="profile-details__checkbox-text">
            {{ labels.critical }}
          </div>
        </div>
      </div>
      <div class="profile-details__key">
        {{ profileKeys.useLastToFirstDnOrder }}
      </div>
      <div class="profile-details__value">
        @if (val.useLastToFirstDnOrder) {
          <svg-icon icon="checkbox-checked"></svg-icon>
        } @else if (!val.useLastToFirstDnOrder) {
          <svg-icon icon="checkbox-unchecked"></svg-icon>
        } @else {
          {{ labels.na }}
        }
      </div>
      <div class="profile-details__key">
        {{ profileKeys.ca }}
      </div>
      <div class="profile-details__value">
        {{ val.ca || labels.na }}
      </div>
      <div class="profile-details__key">
        {{ profileKeys.caIssuerURI }}
      </div>
      <div class="profile-details__value">
        {{ val.caIssuerURI || labels.na }}
      </div>
      <div class="profile-details__key">
        {{ profileKeys.pathLengthConstraint }}
      </div>
      <div class="profile-details__value">
        {{ val.pathLengthConstraint ?? labels.na }}
      </div>
      <div class="profile-details__key">
        {{ profileKeys.profileType }}
      </div>
      <div class="profile-details__value">
        {{ val.profileType || labels.na }}
      </div>
      <div class="profile-details__key">
        {{ profileKeys.notBeforeOffset }}
      </div>
      <div class="profile-details__value">
        {{ val.notBeforeOffset || labels.na }}
      </div>
      <div class="profile-details__key profile-details_bottom-left">
        {{ profileKeys.ocspServiceLocator }}
      </div>
      <div class="profile-details__value profile-details_bottom-right">
        {{ val.ocspServiceLocator || labels.na }}
      </div>
    </div>
  }
</section>
